import { Component, OnInit } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { TranslateService } from '@app/core/services/translate.service';
import { P2ReportDefinitionService } from '@app/services/p2-report-definition.service';
import { VtPage, VtService } from '@app/services/vt.service';

@Component({ selector: 'tt-vt', templateUrl: './vt.component.html', styleUrls: ['./vt.component.css'], standalone: false })
export class VtComponent implements OnInit {
    public page?: VtPage;
    public selectListLanguages: Item[] = [];
    public selectListWebPages: Item[] = [];
    public lockedSave = false;
    public translations = { error: 'Error', ok: 'OK', done: 'Done' };

    constructor(private vtService: VtService, private pages: P2ReportDefinitionService, private state: StateService, private translate: TranslateService, private modal: ModalService) {}

    public get selectedLanguageIds(): string[] { return (this.page?.destin_language_id ?? '').split(',').map(id => id.trim()).filter(Boolean); }

    public onLanguagesChanged(event: Event): void {
        if (!this.page) return;
        const select = event.target as HTMLSelectElement;
        this.page.destin_language_id = Array.from(select.selectedOptions).map(option => option.value).join(',');
        if (this.page.destin_language_id) this.page.destin_language_id += ',';
    }

    public clearWebPage(): void { if (this.page) this.page.vtlink_p2_webpage_keyno = ''; }

    public async saveChanges(): Promise<void> {
        if (!this.page) return;
        this.lockedSave = true;
        try {
            const response = (await this.vtService.saveObj(this.page))[0];
            if (response && response.errorcode !== '0') {
                await this.modal.show({ type: 'warning', title: this.translations.error, message: response.errormessage, buttons: [{ label: this.translations.ok, cssClass: 'btn-warning', type: 'warning', close: true }] });
                return;
            }
            this.state.back();
        } finally { this.lockedSave = false; }
    }

    public async translateAndPublish(): Promise<void> {
        if (!this.page) return;
        this.lockedSave = true;
        try {
            const response = (await this.vtService.translateAndPublish(this.page))[0];
            await this.modal.show({
                type: response && response.errorcode !== '0' ? 'danger' : 'success',
                title: response && response.errorcode !== '0' ? this.translations.error : this.translations.done,
                message: response?.errormessage ?? '',
                buttons: [{ label: this.translations.ok, cssClass: response && response.errorcode !== '0' ? 'btn-danger' : 'btn-success', close: true }],
            });
        } finally { this.lockedSave = false; }
    }

    public async ngOnInit(): Promise<void> {
        const params = this.state.getStateParams();
        const [page, languages, webPages, translations] = await Promise.all([
            this.vtService.getEdit({ vt_keyno: params['vt_keyno'] ?? '0' }), this.vtService.listLanguages(), this.pages.listWebPages(),
            this.translate.translateBatch(['error', 'ok', 'done']),
        ]);
        this.page = page[0];
        this.selectListLanguages = languages;
        this.selectListWebPages = webPages;
        this.translations = { error: translations['error'] ?? this.translations.error, ok: translations['ok'] ?? this.translations.ok, done: translations['done'] ?? this.translations.done };
    }
}
